import { render, staticRenderFns } from "./Breakwater.vue?vue&type=template&id=6e694929&"
import script from "./Breakwater.vue?vue&type=script&lang=js&"
export * from "./Breakwater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports